import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'dq-page-template',
  templateUrl: './page-template.component.html',
  styleUrls: ['./page-template.component.css'],
})
export class PageTemplateComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
